import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    constructor() {}

    checkEmptyString(value: string): boolean {
        return (value || '').trim().length !== 0;
    }
}
